var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSecurityLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M32.455 40.872h27.302a6 6 0 016 6v19.441a6 6 0 01-6 6H32.455a6 6 0 01-6-6V46.872a6 6 0 016-6zm13.65 14.992a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zm0 6.751v-6.751M33.12 40.751v-7.987c0-7.122 5.773-12.896 12.896-12.896 7.122 0 12.895 5.774 12.895 12.896v7.987m-20.757-3.526v-3.887a7.86 7.86 0 1115.72 0v3.887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.595 21.997c.03.025-.02.087-.045.119-4.604 1.11-9.3 1.887-14.013 2.24-.056.006-.087-.019-.118-.044-.603-1.672-1-3.28-1.202-4.936-.06-.307.166-.586.473-.647l8.527-1.124c.057-.006.082-.037.076-.093-.285-2.445-.652-5.933-.937-8.377-.006-.056.019-.087.075-.093l5.25-.381c.056-.006.087.019.093.075.053.507 1.198 9.772 1.82 13.261z",
    fill: "#FF94CA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.396,
    cy: 82.396,
    r: 4,
    fill: "#006AFF",
    transform: "rotate(-174 70.396 82.396)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 72,
    r: 3,
    fill: "#FF94CA",
    fillRule: "nonzero",
    transform: "rotate(-180 82 72)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurityLock);
export default __webpack_public_path__ + "static/media/icon-security-lock.ce63b565.svg";
export { ForwardRef as ReactComponent };